<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Kreditvurdering</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <p class="orange med-text align-center">
    <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
    <br />
    <span>Kunden er ikke kreditværdig!</span>
    <br />
    <span>
      <em>{{ kreditvurdering?.aarsagTekst }}</em>
    </span>
  </p>
</div>
<div mat-dialog-actions class="row-reverse">
  @if (kreditvurdering?.kreditvaerdig !== kreditvaerdigEnum.No) {
    <button
      mat-raised-button
      color="primary"
      (click)="accept()"
      cdkFocusInitial
      >
      @if (buttonText) {
        <span>{{ buttonText }}</span>
      }
      @if (!buttonText) {
        <span>Fortsæt oprettelse</span>
      }
    </button>
  }
  <button mat-raised-button mat-dialog-close>Fortryd</button>
</div>
